import { Avatar, Box, Button, Card, CardContent, CardHeader, Checkbox, FormControl, FormControlLabel, InputLabel, List, ListItem, ListItemAvatar, ListItemText, MenuItem, Select, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Job } from "../../../data/interfaces/tablegenmodels";
import NLCList from "../../../shared/nlclist";
import { updateselectedNlcs } from "../../../stores/jobsslice";
import { useAppDispatch, useAppSelector } from "../../../stores/hooks";
import jobService from "../../../data/api/job.service";
import { JobType } from "../../../data/interfaces/jobmodels";
import { Build } from "@mui/icons-material";
import { ReleaseTableContext } from "./releasemain";
import React from "react";

interface SearchSettings{
    SelectedJobs:number[],
    IncludeGlobalTables:boolean,
    TicketTypes:number[],
    SelectedNlcs:number[]
}

export default function CreateReleaseFilter() {
    const { setReleaseTables,setIsCreateJob } = useContext(ReleaseTableContext);
    const [selectedType, setSelectedType] = useState<string>('0');
    const [jobs, setJobs] = useState<Job[]>([]);
    const [searchSettings,setSearchSettings]=useState<SearchSettings>(
         {SelectedJobs:[],IncludeGlobalTables:true,TicketTypes:[1,2],SelectedNlcs:[]}
    );
    const [includeStationtables, setIncludeStationtables] = useState<boolean>(false);
    const dispatch=useAppDispatch();
    const selectedNlcs = useAppSelector((state) => state.jobsSliceReducer.selectedNlcs);

    useEffect(() => {
        if(selectedType=='0'){
            jobService.getJobs(true,JobType.Build,'4','3',null,false).then((response)=>{
                if(response&&response.data)
                    setJobs(response.data)
            });
            
        }
        setSearchSettings({SelectedJobs:[],IncludeGlobalTables:true,TicketTypes:[1,2],SelectedNlcs:[]})
    }, [selectedType]);
    
    useEffect(()=>{
        let tempSettings={...searchSettings};
        tempSettings.SelectedNlcs=selectedNlcs.flatMap(a=>{return a.Id});
        setSearchSettings(tempSettings);
    },[selectedNlcs])
  

    useEffect(()=>{
        if(!includeStationtables)
            dispatch(updateselectedNlcs([]))
    },[includeStationtables]);

    useEffect(()=>{
        jobService.getReleasedTables(searchSettings.TicketTypes,searchSettings.SelectedNlcs,
        searchSettings.SelectedJobs,searchSettings.IncludeGlobalTables,selectedType).then((response)=>{
            if(response&&response.data)
                setReleaseTables(response.data);
        })
    },[searchSettings]);
    const handleGlobaltables=(checked:boolean)=>{
        let tempSettings={...searchSettings};
        tempSettings.IncludeGlobalTables=checked;
        setSearchSettings(tempSettings);
    }
    const handleSelectJob = (checked:boolean, id: number | undefined) => {
        if (id) {
            let tempSettings={...searchSettings};
            if(checked)
                tempSettings.SelectedJobs.push(id);
            else
                tempSettings.SelectedJobs.splice(tempSettings.SelectedJobs.findIndex(a => a == id), 1);
            setSearchSettings(tempSettings);
        }
    }

    const handleTicketTypeToggle = (checked: boolean, type: number) => {
        let tempSettings={...searchSettings};
        if (checked)
            tempSettings.TicketTypes.push(type);
        else
            tempSettings.TicketTypes.splice(tempSettings.TicketTypes.findIndex(a => a == type), 1);
        setSearchSettings(tempSettings);
    }
    const ReleaseSettingsHeader=()=>{
        return(
            <Box sx={{display:'flex',justifyContent:'space-between'}}>
        <Typography variant="h6">Select Settings</Typography>
        <Button variant="contained" onClick={()=>setIsCreateJob(false)}>Back</Button>
            </Box>
        )
    }

    return (
        <Card>
            <CardHeader title={<ReleaseSettingsHeader/>}></CardHeader>
            <CardContent>
                <Box>
                    <Box sx={{ mb: 2 }}>
                        <Select fullWidth defaultValue={'0'} label="Select Release Type" size="small" onChange={(event,) => { setSelectedType(event.target.value) }}>
                            <MenuItem value={'0'}>By Build Jobs</MenuItem>
                            <MenuItem value={'1'}>By Table Types</MenuItem>
                        </Select>
                    </Box>
                    <Box>
                        {selectedType == '0' ?
                            <Box>
                                <List disablePadding={true} dense={true}>
                                    {jobs.map((job) => {
                                        return (
                                           
                                           
                                            
                                            <ListItem
                                                key={job.Id}
                                                
                                                secondaryAction={
                                                    
                                                    
                                                    <Checkbox
                                                        edge="start"
                                                        checked={searchSettings.SelectedJobs.findIndex(a => a == job.Id) > -1}
                                                        tabIndex={-1}
                                                        disableRipple
                                                        onChange={(event) => handleSelectJob(event.target.checked, job.Id)}
                                                        inputProps={{ 'aria-labelledby': job.JobNumber }}
                                                    />
                                                }><ListItemAvatar>
                                                <Avatar sx={{ backgroundColor: 'primary.main' }}><Build /></Avatar>
                                            </ListItemAvatar>
                                            {/* <ListItemText primary={job.JobNumber} /> */}
                                            <ListItemText  primary={
                                               
                                               <Box sx={{display:"flex", flexDirection:"column"}}>
                                <Typography component="span" variant="body2" color="text.primary">
                                    {job.JobNumber}
                                </Typography>
                                
                                <Typography component="span" variant="body2" color="text.secondary">
                                    {job.Description}
                                </Typography>
                                </Box>
                                
                        } 
                    />
                                                    </ListItem>
                                                     )
                                    })}
                                </List>

                            </Box> 
                            :
                            <Box >
                                <Box sx={{ display: 'flex', width: '100%' }} >
                                    <FormControlLabel sx={{ display: 'flex', justifyContent: 'start', mr: 2 }} labelPlacement="end"
                                        control={<Checkbox checked={searchSettings.TicketTypes.findIndex(a => a == 1) > -1} onChange={(event) => handleTicketTypeToggle(event.target.checked, 1)} />} label="Magnetic" />
                                    <FormControlLabel sx={{ display: 'flex', justifyContent: 'start', mr: 2 }} labelPlacement="end"
                                        control={<Checkbox checked={searchSettings.TicketTypes.findIndex(a => a == 2) > -1} onChange={(event) => handleTicketTypeToggle(event.target.checked, 2)} />} label="ITSO" />
                                </Box>
                                <Box sx={{ display: 'flex', width: '100%' }} >
                                    <FormControlLabel sx={{ display: 'flex', justifyContent: 'start', mr: 2 }} labelPlacement="end"
                                        control={<Checkbox checked={searchSettings.IncludeGlobalTables} onChange={(event) =>handleGlobaltables(event.target.checked)} />} label="Global" />
                                    <FormControlLabel sx={{ display: 'flex', justifyContent: 'start', mr: 2 }} labelPlacement="end"
                                        control={<Checkbox checked={includeStationtables} onChange={(event) => setIncludeStationtables(event.target.checked)} />} label="Station Specific" />
                                </Box>
                                {includeStationtables?
                                    <NLCList parent="create_job_output" disabled={false} />:null
                                }
                                
                            </Box>

                        }
                    </Box>
                </Box>
            </CardContent>
        </Card>
    )
}